import React from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { Button } from '../../../common/components';
import InviteApplicantsStyles from './invite_applicants_styles';
// import Internal from './internal';
import External from './external';

const propTypes = {
  inviteCategory: PropTypes.string.isRequired,
  inviteType: PropTypes.string.isRequired,
  inviteInfo: PropTypes.shape({ get: PropTypes.func }).isRequired,
  invitePath: PropTypes.string.isRequired,
};

const defaultProps = {};

const InviteApplicantsView = ({ inviteCategory, inviteType, inviteInfo, invitePath }) => {
  if (!inviteInfo) {
    // If we don't have the record loaded, drop down to the details page to discover it
    return <Redirect to="." />;
  }

  return (
    <InviteApplicantsStyles>
      <Link to=".">
        <Button size="small" buttonType="back">
          <KeyboardBackspaceIcon />
          Back to {inviteCategory}
        </Button>
      </Link>
      {/* <Internal inviteType={inviteType} inviteInfo={inviteInfo} invitePath={invitePath} /> */}
      <External inviteCategory={inviteCategory} inviteType={inviteType} inviteInfo={inviteInfo} invitePath={invitePath} />
    </InviteApplicantsStyles>
  );
};

InviteApplicantsView.propTypes = propTypes;
InviteApplicantsView.defaultProps = defaultProps;

export default InviteApplicantsView;
